import {useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import NoItemFoundPage from '../../components/noItemFoundPage';
import SpinnerLoading from '../../components/SpinnerLoading';
import useGetBasket from '../../services/hookService/getBasket/useGetBasket';
import BasketHeader from './components/BasketHeader';
import BasketItemCard from './ItemCard/BasketItemCard';

const ShoppingBasket = () => {
  const navigate = useNavigate();

  const {data, isLoading} = useGetBasket();

  const totalPrice = useMemo(() => {
    if (!data?.length) return;
    return data?.reduce((sum, item) => {
      return sum + item.discount_price;
    }, 0);
  }, [data]);

  if (isLoading)
    return (
      <div className="flex flex-col items-center justify-center w-full h-dvh">
        <SpinnerLoading size={50} />
      </div>
    );

  return (
    <div className="flex flex-col w-full h-dvh">
      <BasketHeader />

      <div className="flex flex-col w-full h-full gap-3 p-3 overflow-y-auto">
        <span className="text-gray-800 text-md">محصولات موجود در سبد خرید</span>

        {/* handle no data page */}
        {data?.length ? (
          <>
            {data?.map(cardItem => (
              <BasketItemCard key={cardItem.guid} cardItem={cardItem} />
            ))}
            <p
              className="py-1 mr-auto text-md text-farm-shop-500"
              onClick={() => navigate('/home')}
            >
              + افزودن مورد جدید
            </p>
          </>
        ) : (
          <NoItemFoundPage />
        )}
      </div>

      {/* handle no data page */}
      {data?.length ? (
        <>
          <div className=" w-full h-20 grid grid-cols-2 px-4 py-3 bg-white shadow-[0px_-1px_6px_0px_rgba(0,_0,_0,_0.1)]">
            <div className="flex flex-col items-start">
              <span className="text-gray-600 text-md">قیمت کل</span>
              <span>{totalPrice?.toLocaleString()} تومان</span>
            </div>

            <button
              className="w-full text-white rounded-lg bg-farm-shop-500"
              onClick={() => navigate('/complete-info')}
            >
              تایید و ادامه
            </button>
          </div>
        </>
      ) : (
        <div className="p-6 mb-2">
          <button
            className="w-full py-3 text-white rounded-lg bg-farm-shop-500"
            onClick={() => navigate('/home')}
          >
            افزودن محصول
          </button>
        </div>
      )}
    </div>
  );
};

export default ShoppingBasket;
